
export enum FundOperations {
    NONE = 0,
    CHANGE_NAME = 1,
    CHANGE_NOTES = 2,
    VIEW_LOGS = 4,
    VIEW_TRANSACTIONS = 8,
    PAYMENT = 16,
    TRANSFER = 32,
    DELETE = 64,
}
